/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import Backbone from 'backbone';
import Promise from 'bluebird';
import * as store from '@bingads-webui-component-legacy/steps-wizard/actions/store';
import Viewmodel from '@bingads-webui-component-legacy/steps-wizard/viewmodel/steps';
import Model from '@bingads-webui-component-legacy/steps-wizard/model/indicator';
import layoutHorizontal from '@bingads-webui-component-legacy/steps-wizard/template/layout-horizontal.pug';
import layoutVertical from '@bingads-webui-component-legacy/steps-wizard/template/layout-vertical.pug';
import assert from '@bingads-webui-component-legacy/assert/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/steps-wizard');
var defaultOptions = {
  contentClass: '',
  showCancelBtn: true,
  enableStepSwitch: false
};
function refreshRailViewId() {
  if (window.ApexPlatform) {
    window.ApexPlatform.Refresh();
  }
}
var View = Backbone.View.extend({
  events: {
    'click .step-href': 'switchStep'
  },
  initialize: function (options) {
    var defaultButtons = [{
      key: 'next',
      cssClass: 'btn-primary',
      visible: function () {
        return !this.isLast();
      },
      Text: i18n.get('Button_SaveAndGo'),
      event: _.bind(this.next, this)
    }, {
      key: 'finish',
      cssClass: 'btn-primary',
      visible: function () {
        return this.isLast();
      },
      Text: i18n.get('Button_Save'),
      event: _.bind(this.save, this)
    }, {
      key: 'back',
      cssClass: 'btn-default',
      visible: function () {
        return this.stepIndex() > 0;
      },
      Text: i18n.get('Button_Back'),
      event: _.bind(this.back, this)
    }, {
      key: 'cancel',
      cssClass: 'btn-default',
      visible: function () {
        return true;
      },
      Text: i18n.get('Button_Cancel'),
      event: _.bind(this.cancel, this)
    }];
    this.options = _.defaults({}, options, defaultOptions);
    this.i18nStrings = _.defaults({}, this.options.i18nStrings, defaultOptions.i18nStrings);
    this.model = new Model({
      steps: options.steps,
      stepIndex: options.stepIndex
    });
    this.model.on('subtitle.update', (function (content, delta) {
      this.setSubtitleTemplate(content, delta);
    }).bind(this));
    var customButtons = _.map(this.options.customButtons, function (button) {
      if (_.isObject(button)) {
        if (button.extendDefaultButtons === true) {
          var buttonExtended = _.findWhere(defaultButtons, {
            key: button.key
          });
          var extendedParameters = button.extendedParameters;
          return _.extend({}, buttonExtended, extendedParameters);
        } else {
          return _.extend({}, {
            visible: function () {
              return true;
            }
          }, button);
        }
      }
      if (_.isString(button)) {
        return _.findWhere(defaultButtons, {
          key: button
        });
      }
      throw new Error('Invalid type for custom button');
    });
    this.ko_model = new Viewmodel({
      steps: this.model.get('steps'),
      stepIndex: this.model.get('stepIndex'),
      customButtons: customButtons,
      showCancelBtn: this.options.showCancelBtn
    });
    if (!_.isArray(this.model.get('steps')) || _.isEmpty(this.model.get('steps'))) {
      throw new Error('model.steps must be an array with at least 1 step');
    }
    if (!_.isFunction(this.options.template)) {
      this.options.template = this.options.direction === 'vertical' ? layoutVertical : layoutHorizontal;
    }
  },
  logStepActivity: function (message) {
    var currentStep = this.ko_model.stepIndex();
    if (this.stepActivities && this.stepActivities[currentStep]) {
      this.stepActivities[currentStep].signal(message);
    }
  },
  renderStep: function (index, StepView) {
    var stepWrappers = this.$('.steps-wizard__content .content-wrapper');
    var step = this.model.get('steps')[index];
    step.instance = new StepView(_.defaults({}, step.options, {
      context: this.model,
      dispatch: this.dispatchAction.bind(this),
      newI18n: this.options.deps && this.options.deps.i18nNewDesign
    })).render();
    this.$(stepWrappers[index]).empty().append(step.instance.el);
  },
  renderStepAsync: function (index) {
    var step = this.model.get('steps')[index];
    return step.viewFactory().then(StepView => {
      this.renderStep(index, StepView);
    });
  },
  renderStepSync: function (index) {
    var step = this.model.get('steps')[index];
    this.renderStep(index, step.viewFactory);
  },
  render: function () {
    this.$el.html(this.options.template({
      i18n: i18n,
      i18nStrings: this.i18nStrings,
      steps: this.model.get('steps'),
      contentClass: this.options.contentClass,
      enableStepSwitch: this.options.enableStepSwitch
    }));
    ko.applyBindings(this.ko_model, this.el);
    var stepWrappers = this.$('.steps-wizard__content .content-wrapper');
    if (this.options.stageStepLoading) {
      this.renderStepSync(0);
    } else {
      _.each(stepWrappers, function (e, index) {
        this.renderStepSync(index);
      }, this);
    }
    _.each(this.ko_model.customButtons(), function (button) {
      this.$('.btn-' + button.key).click(button.event);
    }, this);
    var currentStep = this.ko_model.currentStep().instance;
    if (_.isObject(currentStep) && _.isFunction(currentStep.willShow)) {
      currentStep.willShow();
    }
    refreshRailViewId();
    return this;
  },
  getStepInstance: function (index) {
    return this.model.get('steps')[index].instance;
  },
  go2targedStep: function (targetedStep) {
    var direction, predict;
    if (this.ko_model.maxAvailabeStepIndex() < targetedStep || this.ko_model.stepIndex() === targetedStep) {
      return;
    }
    var currentStepInstance = this.getStepInstance(this.ko_model.stepIndex());
    if (this.ko_model.stepIndex() < targetedStep) {
      if (!_.isFunction(currentStepInstance.hasChanges) || currentStepInstance.hasChanges()) {
        this.ko_model.maxAvailabeStepIndex(this.ko_model.stepIndex());
        return;
      }
      direction = 'next';
      predict = '@bingads-webui-component-legacy/test/util/shouldNext';
    } else {
      direction = 'prev';
      predict = '@bingads-webui-component-legacy/test/util/shouldBack';
    }
    this.logStepActivity('switch step to: ' + (targetedStep + 1));
    var targetedStepInstance = this.getStepInstance(targetedStep);
    var args = {
      stepIndex: this.ko_model.stepIndex(),
      stepFrom: currentStepInstance,
      stepTo: targetedStepInstance,
      direction: direction,
      delta: targetedStep - this.ko_model.stepIndex()
    };
    this.trigger('begin:switch', args);
    if (_.isFunction(targetedStepInstance.willShow)) {
      targetedStepInstance.willShow();
    }
    this.ko_model.stepIndex(targetedStep);
    if (_.isFunction(targetedStepInstance.didSwitch)) {
      targetedStepInstance.didSwitch();
    }
    this.trigger('end:switch', args);
    refreshRailViewId();
  },
  switchStep: function (e) {
    if (!this.options.enableStepSwitch) {
      return;
    }
    this.go2targedStep(parseInt(e.currentTarget.dataset.target));
  },
  next: function () {
    assert.ok(!this.ko_model.isLast(), 'The last step cannot go next');
    var currentStepIndex = this.ko_model.stepIndex();
    var nextStepIndex = currentStepIndex + 1;
    var currentStepInstance = this.model.get('steps')[currentStepIndex].instance;
    var nextStepInstance = this.model.get('steps')[nextStepIndex].instance;
    var loadingDependency = Promise.resolve({});
    if (this.options.stageStepLoading && !nextStepInstance) {
      var step = this.model.get('steps')[nextStepIndex];
      if (step.options && step.options.isDelayLoading) {
        loadingDependency = this.renderStepAsync(nextStepIndex).then(() => {
          nextStepInstance = this.model.get('steps')[nextStepIndex].instance;
        });
      }
    }
    return loadingDependency.then((function () {
      return Promise.resolve(!_.isFunction(currentStepInstance.shouldNext) || currentStepInstance.shouldNext()).then((function (shouldNext) {
        if (shouldNext) {
          this.logStepActivity('clicked next: successful');
          this.trigger('begin:switch', {
            stepIndex: this.ko_model.stepIndex(),
            stepFrom: currentStepInstance,
            stepTo: nextStepInstance,
            direction: 'next'
          });
          if (_.isFunction(nextStepInstance.willShow)) {
            nextStepInstance.willShow();
          }
          this.ko_model.stepIndex(this.ko_model.stepIndex() + 1);
          if (this.ko_model.maxAvailabeStepIndex() < this.ko_model.stepIndex()) {
            this.ko_model.maxAvailabeStepIndex(this.ko_model.stepIndex());
          }
        } else {
          this.logStepActivity('clicked next: failed');
        }
      }).bind(this)).finally((function () {
        this.trigger('end:switch', {
          stepIndex: this.ko_model.stepIndex(),
          stepFrom: currentStepInstance,
          stepTo: nextStepInstance,
          direction: 'next'
        });
        if (_.isFunction(nextStepInstance.didSwitch)) {
          nextStepInstance.didSwitch();
        }
        refreshRailViewId();
      }).bind(this));
    }).bind(this));
  },
  back: function () {
    assert.ok(this.ko_model.stepIndex() > 0, 'The first step cannot go back');
    var currentStepInstance = this.model.get('steps')[this.ko_model.stepIndex()].instance;
    var previousStepInstance = this.model.get('steps')[this.ko_model.stepIndex() - 1].instance;
    return Promise.resolve(!_.isFunction(currentStepInstance.shouldBack) || currentStepInstance.shouldBack()).then((function (shouldBack) {
      if (shouldBack) {
        this.logStepActivity('clicked back: successful');
        this.trigger('begin:switch', {
          stepIndex: this.ko_model.stepIndex(),
          stepFrom: currentStepInstance,
          stepTo: previousStepInstance,
          direction: 'prev'
        });
        if (_.isFunction(previousStepInstance.willShow)) {
          previousStepInstance.willShow();
        }
        this.ko_model.stepIndex(this.ko_model.stepIndex() - 1);
      } else {
        this.logStepActivity('clicked back: failed');
      }
    }).bind(this)).finally((function () {
      this.trigger('end:switch', {
        stepIndex: this.ko_model.stepIndex(),
        stepFrom: currentStepInstance,
        stepTo: previousStepInstance,
        direction: 'prev'
      });
      if (_.isFunction(previousStepInstance.didSwitch)) {
        previousStepInstance.didSwitch();
      }
      refreshRailViewId();
    }).bind(this));
  },
  cancel: function () {
    var currentStepInstance = this.model.get('steps')[this.ko_model.stepIndex()].instance;
    return Promise.resolve(!_.isFunction(currentStepInstance.shouldCancel) || currentStepInstance.shouldCancel()).then((function (shouldCancel) {
      if (shouldCancel) {
        this.trigger('cancel', {
          stepIndex: this.ko_model.stepIndex()
        });
      }
      return shouldCancel;
    }).bind(this));
  },
  save: function () {
    assert.ok(this.ko_model.isLast(), 'The save function should only be triggered in the last step');
    var currentStepInstance = this.model.get('steps')[this.ko_model.stepIndex()].instance;
    return Promise.resolve(!_.isFunction(currentStepInstance.save) || currentStepInstance.save()).then((function (shouldNext) {
      if (shouldNext) {
        this.trigger('complete', {
          stepIndex: this.ko_model.stepIndex()
        });
      }
      return shouldNext;
    }).bind(this));
  },
  remove: function () {
    _.each(this.model.get('steps'), function (step) {
      step.instance && _.isFunction(step.instance.remove) && step.instance.remove();
    });
    Backbone.View.prototype.remove.apply(this, arguments);
  },
  setSubtitleTemplate: function (content, stepIndex) {
    stepIndex++;
    this.$('.step-wizard__substep:nth-child(' + stepIndex + ') .section-header__subtitle-content').empty().append(content);
  },
  dispatchAction: function (action) {
    var handler = store.default[action.type];
    if (_.isFunction(handler)) {
      return handler(this, action);
    }
    throw new Error('Unrecognized action');
  }
});
export default View;

